module.exports = " <div class=radio-input> <div class=form-group> <label v-bind:for=field.name class=\"col-sm-4 control-label\">{{ field.label }} <span v-if=field.required class=required>*</span></label> <div class=col-sm-8> <div class=radio v-for=\"radioLabel in field.radioLabels\"> <label> <input class=radio v-bind:id=field.name type=radio v-bind:value=radioLabel v-model=field.value v-bind:name=field.name /> {{ radioLabel }} </label> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/RadioInput.vue
// module id = 742
// module chunks = 2